// extracted by mini-css-extract-plugin
export var checkbox = "checkbox-module--checkbox--d49b4";
export var checkboxContainer = "checkbox-module--checkboxContainer--20824";
export var checkboxLabel = "checkbox-module--checkboxLabel--5b6f9";
export var dark = "checkbox-module--dark--2d6f3";
export var disabled = "checkbox-module--disabled--638c7";
export var enabled = "checkbox-module--enabled--e6182";
export var error = "checkbox-module--error--2ba0c";
export var light = "checkbox-module--light--85984";
export var medium = "checkbox-module--medium--f7c13";
export var small = "checkbox-module--small--a2292";